import useApiMutation from 'shared/hooks/use-api-mutation';
import {DistanceProps} from '../types';
import citiesKeys from '../util/cities-keys';
import useQueryHelpers from 'shared/hooks/use-query-helpers';

const useCreateDistance = (cityId: string) => {
  const {create} = useQueryHelpers();

  const onSuccess = (data: DistanceProps) =>
    create(citiesKeys.distances(cityId), data);

  return useApiMutation<DistanceProps>({
    url: '/distances',
    method: 'POST',
    errorTitle: 'Erro ao cadastrar distância',
    successTitle: 'Distância cidade',
    successMessage: 'Distância cadastrada com sucesso',
    redirectUrl: `/settings/cities/${cityId}/distances`,
    onSuccess,
  });
};

export default useCreateDistance;
